import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CanActivateChild, CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private _authService: AuthService, private _router: Router) { }
  
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  // Can activate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const redirectUrl = state.url === '/pages/auth/login' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  // Can activate child
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url === '/pages/auth/login' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  // Can load  
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this._check('/');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  // Check the authenticated status
  private _check(redirectURL: string): Observable<boolean> {
    // Check the authentication status
    return this._authService.check().pipe(switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {        
        // Redirect to the login page
        this._router.navigate(['/pages/auth/login'], { queryParams: { redirectURL } });

        // Prevent the access
        return of(false);
      }

      // Allow the access
      return of(true);
    }));
  }
}